'use client';

import './index.css';

import { storyblokEditable } from '@storyblok/react';

import { InlineForm } from '@/components/inline-form';
import { MaxWidth } from '@/components/max-width';

import { markdownToHtml } from '@/helpers/string';

export const LandingFormClient = ({ blok }) => {
  const TitleEl = blok.titleLevel || 'h3';

  const form = blok.form?.[0];

  return (
    <div {...storyblokEditable(blok)} className="landing-form">
      <MaxWidth>
        <div className="landing-form__wrap">
          {blok.title ? (
            <TitleEl
              className="landing-form__title"
              dangerouslySetInnerHTML={{
                __html: markdownToHtml(blok.title),
              }}
            />
          ) : null}

          <div className="landing-form__form">
            <InlineForm
              emailInputId={form?.emailInputId}
              emailLabel={form?.emailLabel}
              submitLabel={form?.submitLabel}
              submitLabelMobile={form?.submitLabelMobile}
              successMessage={form?.successMessage}
              errorMessage={form?.errorMessage}
              codeConvertkit={form?.codeConvertkit}
              brevoListId={form?.brevoListId}
            />
          </div>
        </div>
      </MaxWidth>
    </div>
  );
};
